import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { setFlow } from '../../store/flow/action-creators';
import { isEligibleForACQ177ProductisedFlow } from '../../utils/gtkm/isEligibleForACQ177ProductisedFlow';
import { getIsExistingUserSession } from '../../store/app/selectors';
import { getCurrentStep } from '../../store/flow/selectors';
import { isPurchaseProductisedFlow } from '../../utils/gtkm/isPurchaseProductisedFlow';
import { isMarketingProductisedFlow } from '../../utils/gtkm/isMarketingProductisedFlow';
export const BranchACQ0177VariantA = {
  name: 'BranchACQ0177VariantA',
  stateCheck: state => {
    if (isEligibleForACQ177ProductisedFlow(state)) {
      return true;
    }
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0177, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const {
      preVerification,
      postExistingAccountSelection,
      postAccountCreation
    } = getFlowSteps();
    if (getIsExistingUserSession(state) && (isPurchaseProductisedFlow() || isMarketingProductisedFlow())) {
      const existingUserAccountSelectionSteps = [Step.ExistingAccounts];
      const isAlreadyOnExistingUserStep = getCurrentStep(state) === Step.ExistingUser;
      const nextSteps = [...(isAlreadyOnExistingUserStep ? [] : [Step.ExistingUser]), ...existingUserAccountSelectionSteps, Step.LoadingPage, ...postAccountCreation];
      dispatch(setFlow(nextSteps, [], [Step.LoadingPage], postAccountCreation, []));
      return nextSteps;
    }

    // We need to add the Password step before the LoadingPage step
    // to ensure the flow length is greater than 1 so that the end of signup logic isn't triggered
    const postVerificationSteps = [Step.LoadingPage, Step.Password];
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerificationSteps, ...postAccountCreation];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, postAccountCreation, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};